import { Outlet } from "react-router-dom";

const Sucursales = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Sucursales;
